import { Link } from "react-router-dom";
import { Package, Mail, Phone, MapPin } from "lucide-react";

// Catégories produits (mêmes labels que le sous-menu sticky en haut)
const CATEGORIES = [
  { label: "Carton déménagement", to: "/cartons-demenagement" },
  { label: "Cartons reconditionnés", to: null },
  { label: "Emballage et protection", to: null },
  { label: "Fermeture et accessoires", to: null },
  { label: "Packs cartons", to: null },
];

const renderLink = ({ label, to }) =>
  to ? (
    <Link to={to} className="text-white/85 hover:text-white transition-colors">
      {label}
    </Link>
  ) : (
    <span className="text-white/70 cursor-default" title="Bientôt disponible">
      {label}
    </span>
  );

const Footer = () => {
  return (
    <footer className="bg-[#237cb5] text-white mt-20" data-testid="site-footer" id="contact">
      <div className="container-cdm py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-6">
            <Link to="/" className="flex items-center gap-2 mb-5">
              <div className="h-9 w-9 bg-white flex items-center justify-center rounded-sm">
                <Package className="h-5 w-5 text-[#237cb5]" strokeWidth={2.5} />
              </div>
              <span className="font-display font-extrabold text-xl">cartonmove</span>
            </Link>
            <p className="text-white/85 text-sm leading-relaxed max-w-sm">
              La boutique en ligne spécialisée dans la vente de cartons et fournitures de
              déménagement en Île-de-France. Qualité professionnelle, livraison rapide.
            </p>
            <div className="mt-6 space-y-2 text-sm text-white/85">
              <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-white" /> 01 23 45 67 89</div>
              <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-white" /> contact@cartonmove.fr</div>
              <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-white" /> Île-de-France</div>
            </div>
          </div>

          {/* Catégories de produits */}
          <div className="md:col-span-6">
            <h4 className="text-[11px] uppercase font-bold tracking-[0.16em] text-white/70 mb-4">
              Nos produits
            </h4>
            <ul className="space-y-2.5 text-sm" data-testid="footer-categories">
              {CATEGORIES.map((c) => (
                <li key={c.label} data-testid={`footer-cat-${c.label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {renderLink(c)}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/20 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/70">
          <div>
            © {new Date().getFullYear()} cartonmove — Cartons & fournitures de déménagement en
            Île-de-France.
          </div>
          <div className="flex gap-4">
            <a href="#" className="hover:text-white">Mentions légales</a>
            <a href="#" className="hover:text-white">CGV</a>
            <a href="#" className="hover:text-white">Politique de confidentialité</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
